import {useCallback, useEffect, useRef} from 'react';
import {useEventListener} from 'usehooks-ts';
import {useAppSelector} from '@hooks/app';
import {touchUserActivity, trackSiteVisitIfNeeded} from '@utils/track';

const ACTIVITY_THROTTLE_MS = 1000;

export const SiteVisitTracker = (): null => {
    const lastTouchRef = useRef(0);
    const token = useAppSelector(state => state.app.token);

    useEffect(() => {
        trackSiteVisitIfNeeded(token);
    }, []);

    const handleActivity = useCallback(() => {
        const now = Date.now();
        if (now - lastTouchRef.current < ACTIVITY_THROTTLE_MS) return;
        lastTouchRef.current = now;
        touchUserActivity();
    }, []);

    useEventListener('mousemove', handleActivity);
    useEventListener('keydown', handleActivity);

    return null;
};
